import { useCallback, useState } from "react";
import { api } from "../lib/api";
import { getMusicKitInstance } from "../lib/appleMusicKit";
import { track } from "../lib/analytics";

// Never falsely claims success — only reports "favorited" after Apple confirms it.
export function useAppleMusicFavorite(appleMusicArtistUrl) {
  const [status, setStatus] = useState("idle"); // idle | authorizing | favorited

  const openFallback = useCallback(() => {
    if (appleMusicArtistUrl) window.open(appleMusicArtistUrl, "_blank", "noopener");
    track("apple_music_artist_page_opened");
    setStatus("idle");
  }, [appleMusicArtistUrl]);

  const favorite = useCallback(async () => {
    if (status === "favorited" || status === "authorizing") return;
    setStatus("authorizing");
    track("apple_music_auth_started");
    try {
      const { data: config } = await api.get("/apple-music/config");
      if (!config.available || !config.developerToken) {
        openFallback();
        return;
      }
      const music = await getMusicKitInstance(config.developerToken);
      const musicUserToken = await music.authorize();
      if (!musicUserToken) {
        openFallback();
        return;
      }
      const { data: res } = await api
        .post("/apple-music/favorite", { musicUserToken })
        .catch(() => ({ data: { ok: false } }));
      if (res?.ok) {
        setStatus("favorited");
        track("apple_music_artist_favorited");
      } else {
        openFallback();
      }
    } catch {
      openFallback();
    }
  }, [status, openFallback]);

  return { status, favorite };
}
